/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiMeetingFeaturesAttendeeCapabilitiesFromJSON, StreemApiMeetingFeaturesAttendeeCapabilitiesToJSON, } from './';
export function StreemApiAttendeeFromJSON(json) {
    return StreemApiAttendeeFromJSONTyped(json, false);
}
export function StreemApiAttendeeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'externalUserId': !exists(json, 'external_user_id') ? undefined : json['external_user_id'],
        'attendeeId': !exists(json, 'attendee_id') ? undefined : json['attendee_id'],
        'joinToken': !exists(json, 'join_token') ? undefined : json['join_token'],
        'attendeeCapabilities': !exists(json, 'attendee_capabilities') ? undefined : StreemApiMeetingFeaturesAttendeeCapabilitiesFromJSON(json['attendee_capabilities']),
    };
}
export function StreemApiAttendeeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'external_user_id': value.externalUserId,
        'attendee_id': value.attendeeId,
        'join_token': value.joinToken,
        'attendee_capabilities': StreemApiMeetingFeaturesAttendeeCapabilitiesToJSON(value.attendeeCapabilities),
    };
}
//# sourceMappingURL=StreemApiAttendee.js.map